import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import './styles/index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { Router } from './routes/Routes';
import { Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import ErrorBoundary from './components/ErrorBoundary';
import { LoadErrorComponent } from './components/LoadErrorComponent';
import { BranchesProvider } from './context/BranchesContext';

function App() {
    return (
        <div className='App vh-100 flex-center'>
            <Suspense fallback={<Spinner animation='border' />}>
                {/* Последната мрежа: екраните без таблица нямат предпазителя от TableViewsWrapper, а
                    без нищо тук всяка грешка при рисуване маха цялото дърво и остава бял екран. */}
                <ErrorBoundary fallback={<LoadErrorComponent messageKey='pageLoadError' />}>
                    {/* <BranchesProvider> */}
                        <Router></Router>
                    {/* </BranchesProvider> */}
                </ErrorBoundary>
            </Suspense>
        </div>
    );
}

export default App;
